import { Component, Inject, OnInit } from '@angular/core';
import { digger } from '@cbre/digger';
import { LookupRefService } from '@shared/services/lookup-ref.service';
import { EDITING_BOX_RECORDS, EDITING_BOX_SECTIONS, EditingBoxConfigItem } from '../editing-box-overlay.config';
import { EditingBoxStreamService } from '../editing-box-stream.service';
import { leaseTermCalcWithLocation, Periods } from './lease-term-const';
import moment from 'moment';
import { getParams, UTC_EDP_INPUT_FORMAT } from '@business-rules/lease/lease-term-calc';
import { LOCALE_ID, AppStorageService } from '@shared/services/app-storage.service';
import { Column } from '@miq/catalog';
import { L10nTranslationService } from 'angular-l10n';

const LABEL_MODE = 'associated';

@Component({
  selector: 'miq-lease-term-edit-box',
  templateUrl: './lease-term-box.component.html',
  styleUrls: ['./lease-term-box.component.scss'],
  standalone: false,
})
export class LeaseTermEditBoxComponent implements OnInit {
  reportSection = [];
  errorMsg: string;
  modifiedColumnns = [];
  localId: number;
  constructor(
    @Inject(EDITING_BOX_SECTIONS) public sections: EditingBoxConfigItem[],
    @Inject(EDITING_BOX_RECORDS) public record: any,
    private streamService: EditingBoxStreamService,
    private lookupRef: LookupRefService,
    private storage: AppStorageService,
    private translationService: L10nTranslationService
  ) {
    this.localId = this.storage.getItem<number>(LOCALE_ID);
  }

  ngOnInit() {
    this.initReportColumns();
  }

  initReportColumns() {
    this.sections.forEach(section => {
      if (section.labelMode && section.labelMode === LABEL_MODE) {
        let recordItem: Column;
        const sectionZeroIndexCoulmn = section.columns[0];
        const sectionFirstIndexCoulmn = section.columns[1];
        recordItem = sectionZeroIndexCoulmn;
        recordItem.unit = sectionFirstIndexCoulmn;
        recordItem.value = digger(this.record, sectionZeroIndexCoulmn.field);
        recordItem.unit.value = digger(this.record, sectionFirstIndexCoulmn.field);
        this.getLookUp(sectionFirstIndexCoulmn.lookupCategory, recordItem);
        this.reportSection.push(recordItem);
      } else if (section.columns && section.columns.length > 0) {
        section.columns.forEach(column => {
          column.value = digger(this.record, column.field);
          this.reportSection.push(column);
        });
      }
    });
    this.validateLeaserTermfileds(false);
  }

  getLookUp(lookupCategory: string, recordItem: Column) {
    this.lookupRef.loadDataFor(lookupCategory).subscribe(res => (recordItem.unit.values = res));
  }

  onColumnValChange({ column, value }, reportSection: Column[]) {
    const section = { columns: reportSection };
    column.value = value;
    const columns = getParams(section);
    const columnToModify = leaseTermCalcWithLocation(this.localId, column, columns, this.record);
    this.validateLeaserTermfileds(false);
    this.modifiedColumnns = [...this.modifiedColumnns, column, columnToModify];
  }

  /**
   * Catures both, field and uom changes, since rdChange is a Column
   * object and is required by editing box event, it's being passed
   * as `column` attribute for the event
   *
   * @param rdChange Column
   */
  onUomChange(rdChange: any, reportSection: Column[]) {
    this.onColumnValChange({ ...rdChange, column: rdChange }, reportSection);
  }

  applyLeaseTermCalc() {
    this.validateLeaserTermfileds(true);
    if (this.errorMsg == null) {
      const {
        entity: { id: recordId },
      } = this.record;

      this.modifiedColumnns = this.modifiedColumnns.filter(val => val != null);
      this.modifiedColumnns.forEach(col => {
        const changeCol = col;
        this.streamService.pushChangeStream({
          recordId,
          column: changeCol,
          field: changeCol.field,
          value: changeCol.value,
        });
      });
      this.modifiedColumnns = [];
    }
  }

  validateLeaserTermfileds(apply: boolean) {
    this.errorMsg = null;
    const section = { columns: this.reportSection };
    const columns = getParams(section);
    const endDate = moment(columns.endDateColumn.value, UTC_EDP_INPUT_FORMAT).utc();
    const startDate = moment(columns.startDateColumn.value, UTC_EDP_INPUT_FORMAT).utc();
    let uomValue = columns.leaseTermColumn.unit.value;
    uomValue = !!Periods[uomValue] ? Periods[uomValue] : Periods.Months;
    const term = Math.round(endDate.diff(startDate, uomValue, true));
    if (startDate.isAfter(endDate) && apply) {
      this.errorMsg = this.translationService.translate('reports.startDateEndDateAlert');
    } else if (!apply) {
      if (term < columns.leaseTermColumn.value) {
        this.errorMsg = this.translationService.translate('reports.shorterTermDatesAlert');
      } else if (term > columns.leaseTermColumn.value) {
        this.errorMsg = this.translationService.translate('reports.longerTermDatesAlert');
      }
    }
  }
}
